function init() {

    const modal = document.getElementById('homepage-modal');

    if (modal) {
        const overlay = modal.querySelector('.ver-modal__overlay');
        const closeBtn = document.getElementById('ver-modal-close');

        const openModal = () => {
            modal.classList.add('is-active');
            document.documentElement.classList.add('modal-open');
        };

        const closeModal = () => {
            modal.classList.remove('is-active');
            document.documentElement.classList.remove('modal-open');
            sessionStorage.setItem('modal_dismissed', 'true');
        };

        // Session check
        if (!sessionStorage.getItem('modal_dismissed')) {
            openModal();
        }

        // Close on button click
        closeBtn.addEventListener('click', closeModal);

        // Close on keyboard (Enter or Space) for accessibility
        closeBtn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
            closeModal();
            }
        });

        // Close on overlay click
        overlay.addEventListener('click', closeModal);

        // Close on Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('is-active')) {
            closeModal();
            }
        });
    }
}

export { init as default }